<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Coberturas por curvas"
    :largura="700"
    @click:primary="salvarCoberturas()"
  >
    <template #ativador>
      <slot name="ativador" :callback="() => dialog_ativo = ! dialog_ativo">
        <v-btn :disabled="props.disabled" color="primary" small @click="dialog_ativo = ! dialog_ativo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
      </slot>
    </template>

    <div class="d-flex align-center">
      <IndicadorImportancia style="rotate: -90deg;position: absolute;margin-left: -201px;margin-top: 8%;" />

      <div class="w-full ml-18px">
        <table id="tabela-curvas-localidade-coberturas">
          <tr class="text-left font-13 font-weight-medium text-white" style="background: #d0c4c4">
            <td class="pl-3">Frequência</td>
            <td>Faturamento</td>
            <td>Local</td>
            <td>Nacional</td>
            <td>Importado</td>
          </tr>

          <tr
            v-for="(item, index) in props.coberturas" :key="index"
            :class="[`background-importancia-${index}`, (index > 0 && Number.isInteger(index / 3)) ? 'dividir-curvas' : undefined]"
            class="font-13"
          >
            <td v-text="item.descricao_pqr" class="pl-3" />
            <td v-text="item.descricao_xyz" />

            <template v-for="campo in campos_editaveis">
              <td class="w-80" :key="campo">
                <div class="d-flex align-center justify-center pb-2 pr-3">
                  <TextFieldFormatadorDeValor
                    v-model="item[campo]"
                    dense
                    class="text-field-centralizado"
                    hide-details
                    style="font-size: 13px"
                    @focus="ev => ev.target.select()"
                    @keydown.enter="salvarCoberturas"
                  />
                </div>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </div>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import IndicadorImportancia from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/IndicadorImportancia.vue";
import * as req from "@/api/compras/CoberturaEsegPorLocalidade.js";
import store from "@/store";
import {logout} from "@/helpers";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: true,
  },
  coberturas: Array
});

const emit = defineEmits(['atualizacao-parametrizacao']);

const campos_editaveis = [
  'tempo_cobertura_esseg_local',
  'tempo_cobertura_esseg_nacional',
  'tempo_cobertura_esseg_importado',
];

const dialog_ativo= ref(false)

function salvarCoberturas() {
  const parametros = props.coberturas.map(item => ({
    pqr: item.pqr,
    xyz: item.xyz,
    tempo_cobertura_esseg_local: item.tempo_cobertura_esseg_local,
    tempo_cobertura_esseg_nacional: item.tempo_cobertura_esseg_nacional,
    tempo_cobertura_esseg_importado: item.tempo_cobertura_esseg_importado,
  }));

  store.dispatch('loading/addRequisicao',
    req.salvarCoberturas({coberturas: parametros})
      .then(() => {
        dialog_ativo.value = false;
        setTimeout(() => emit('atualizacao-parametrizacao', {}), 50);
      })
      .catch(logout)
  );
}
</script>

<style scoped>
#tabela-curvas-localidade-coberturas {
  width: 100%;
  border-collapse: collapse;
}
.dividir-curvas td {
  border-top: 2px solid white;
}
#tabela-curvas-localidade-coberturas tr td {
  color: #171616;
}
.ml-18px {
  margin-left: 18px;
}
.background-importancia-0 {
  background: #e1d0d0;
}
.background-importancia-1 {
  background: #e0d4d4;
}
.background-importancia-2 {
  background: #e5dada;
}
.background-importancia-3 {
  background: #ece3e3;
}
.background-importancia-4 {
  background: #efe8e8;
}
.background-importancia-5 {
  background: #f3efef;
}
.background-importancia-6 {
  background: #f5f1f1;
}
.background-importancia-7 {
  background: #faf7f7;
}
.background-importancia-8 {
  background: #fffbfb;
}
</style>
